import { render, staticRenderFns } from "./HomeAudioOnBoarding.vue?vue&type=template&id=f1137842&scoped=true&"
import script from "./HomeAudioOnBoarding.vue?vue&type=script&lang=js&"
export * from "./HomeAudioOnBoarding.vue?vue&type=script&lang=js&"
import style0 from "./HomeAudioOnBoarding.vue?vue&type=style&index=0&id=f1137842&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1137842",
  null
  
)

export default component.exports